var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.99984L7.5 9.99984M17.5 4.99984L7.5 4.99984M17.5 14.9998L7.5 14.9998M4.16667 9.99984C4.16667 10.4601 3.79357 10.8332 3.33333 10.8332C2.8731 10.8332 2.5 10.4601 2.5 9.99984C2.5 9.5396 2.8731 9.1665 3.33333 9.1665C3.79357 9.1665 4.16667 9.5396 4.16667 9.99984ZM4.16667 4.99984C4.16667 5.46007 3.79357 5.83317 3.33333 5.83317C2.8731 5.83317 2.5 5.46007 2.5 4.99984C2.5 4.5396 2.8731 4.1665 3.33333 4.1665C3.79357 4.1665 4.16667 4.5396 4.16667 4.99984ZM4.16667 14.9998C4.16667 15.4601 3.79357 15.8332 3.33333 15.8332C2.8731 15.8332 2.5 15.4601 2.5 14.9998C2.5 14.5396 2.8731 14.1665 3.33333 14.1665C3.79357 14.1665 4.16667 14.5396 4.16667 14.9998Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMaster);
export default __webpack_public_path__ + "static/media/productMaster.ec177c7801cfa2d554b5f101de3f20de.svg";
export { ForwardRef as ReactComponent };